// extracted by mini-css-extract-plugin
module.exports = {"containerClass":"LandingPage_containerClass__a8aT8","containerHeadingClass":"LandingPage_containerHeadingClass__JETzI"};